import { render, staticRenderFns } from "./previewDialog.vue?vue&type=template&id=47e68594&scoped=true&"
import script from "./previewDialog.vue?vue&type=script&lang=ts&"
export * from "./previewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./previewDialog.vue?vue&type=style&index=0&id=47e68594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e68594",
  null
  
)

export default component.exports